import router from '../router'
import axios from 'axios'
const app = require('../main');

export default {
  actions: {
    toDo(ctx, index) {
      const loader = app.loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .post(`/api/v1/todo/list?companyId=${router.history.current.query.companyId}&taskId=${router.history.current.query.taskId}&type=${index}`)
          .then(response => {
            loader.hide();
            console.log('---/projectTaskMessages/list', response.data.list);
            ctx.commit('updateToDo', response.data.list);
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
    },
  },
  mutations: {
    updateToDo(state, list) {
      state.toDo = list
    }
  },
  state: {
    toDo: [],
  },
  getters: {
    getToDo(state) {
      return state.toDo
    }
  }
}